export const baseURL = '/api/v1/pinterest_manager' as const;

export default {
  pinterestAds: baseURL,
  accounts: `${baseURL}/get_ad_accounts/` as const,
  campaigns: `${baseURL}/get_campaigns` as const,
  adGroups: `${baseURL}/get_ad_groups/` as const,
  pinText: `${baseURL}/get_pin_text/` as const,
  createAd: `${baseURL}/create_ad/` as const,
};
